module.exports = __webpack_public_path__ + "img/logo-ptpos-grey.aac7584f.png";